import { Wall, Rows, GridFour, AppWindow, Lock, GridNine, TextAlignJustify, Door, Dresser, Lightbulb, Plug, Siren,
  Table, Cards, Drop, Broom, Snowflake, Oven, WashingMachine, Wind, Plugs, Square, Toilet, Bathtub, Selection, Fan, Towel,
  Key, Eye, Mailbox, Stairs, Steps, Bell, ThermometerHot, Thermometer, Fire, Lightning, Waves, Gauge, Bug, Circle } from "@phosphor-icons/react";

// Item chip icons — mirrors the walk mocks (grid floor, window panes, lock, blinds slats, door, bulb, outlet, detector…)
const MAP = {
  "Walls": Wall, "Ceiling": Rows, "Floor": GridFour, "Windows": AppWindow, "Window locks": Lock, "Screens": GridNine,
  "Blinds": TextAlignJustify, "Door + lock": Door, "Closet": Dresser, "Lights": Lightbulb, "Outlets": Plug,
  "Smoke detector": Siren, "CO detector": Bell,
  "Counters": Table, "Cabinets": Cards, "Sink": Drop, "Disposal": Broom, "Fridge": Snowflake, "Range": Oven,
  "Dishwasher": WashingMachine, "Hood": Wind, "GFCI": Plugs,
  "Tile/grout": Square, "Vanity": Selection, "Toilet": Toilet, "Tub/shower": Bathtub, "Mirror": Eye, "Fan": Fan, "Towel bars": Towel,
  "Deadbolt": Key, "Peephole": Eye, "Mailbox/Buzzer": Mailbox, "Railing": Steps, "Stairs": Stairs,
  "Heat/AC": ThermometerHot, "Thermostat": Thermometer, "Water heater": Fire, "Panel": Lightning, "Washer hookups": WashingMachine,
  "Dryer vent": Wind, "Shutoffs": Gauge, "Water intrusion": Waves, "Pests": Bug,
};

export default function ItemIcon({ name, size = 22, className = "" }) {
  const I = MAP[name] || Circle;
  return <I weight="fill" size={size} className={className}/>;
}
